import { Multiples, Submultiples } from "../../SIprefixe";
import { Unit, UnitBaseTypes } from "../../Units";

function KiloNewtonMillimetreSquired() {
  return (
    <>
      <Unit unit={UnitBaseTypes.newton} prefix={Multiples.kilo} />
      <Unit unit={UnitBaseTypes.metre} prefix={Submultiples.milli} exponent={2} />
    </>
  );
}

export default KiloNewtonMillimetreSquired;
